import { render, staticRenderFns } from "./social-links.vue?vue&type=template&id=404268a4&scoped=true&"
import script from "./social-links.vue?vue&type=script&lang=js&"
export * from "./social-links.vue?vue&type=script&lang=js&"
import style0 from "./social-links.vue?vue&type=style&index=0&id=404268a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404268a4",
  null
  
)

export default component.exports